/* hs-main.js — buy box binder for sections/hs-main.liquid.
   Owns: tier selection (radio group), header price + ATC label sync, gift unlocks,
   hero image swap, gallery thumbs + arrows, the customer-video strip arrows, delivery date,
   add to cart (native offer only).
   Does NOT own: cart requests (hs-purchase.js), accordions (hs-content.js), video playback
   (snippets/hs-video-card.liquid).
   Offer source "app" (data-offer="app"): the Kaching Bundles block + a plain product form own the
   purchase — this module binds gallery, videos and the date only, and never touches the cart.
   Prices are never computed here — every figure is a server-rendered data attribute built from
   Shopify objects (R-01, R-101). Source order: hs-purchase.js loads first (deferred, document
   order); the native purchase path BAILS loudly and visibly if it is missing (R-56, R-103). */
(function () {
  'use strict';
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function smooth() { return REDUCED ? 'auto' : 'smooth'; }
  function setText(el, v) { if (el && el.textContent !== v) el.textContent = v; }

  /* ---------------------------------------------------------------- gallery
     Thumbs pick a slide by INDEX (R-43); the active thumb follows the rail through an
     IntersectionObserver, never a layout read on scroll (R-89). */
  function bindGallery(root) {
    var rail = root.querySelector('[data-hs-rail]'), strip = root.querySelector('[data-hs-strip]');
    var thumbs = [].slice.call(root.querySelectorAll('[data-hs-thumb]'));
    var slides = [].slice.call(root.querySelectorAll('[data-hs-slide]'));
    var idx = 0;
    function mark(i) {
      idx = i;
      thumbs.forEach(function (b, j) { var on = j === i; b.classList.toggle('is-active', on); if (on) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
      var tb = thumbs[i];
      if (tb && strip && strip.offsetParent !== null) strip.scrollTo({ left: tb.offsetLeft - thumbs[0].offsetLeft - (strip.clientWidth - tb.clientWidth) / 2, behavior: smooth() });
    }
    function go(i) {
      if (!rail || !slides.length) return;
      i = (i + slides.length) % slides.length;
      rail.scrollTo({ left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: smooth() });
      mark(i);
    }
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });
    var prev = root.querySelector('[data-hs-prev]'), next = root.querySelector('[data-hs-next]');
    if (prev) prev.addEventListener('click', function () { go(idx - 1); });
    if (next) next.addEventListener('click', function () { go(idx + 1); });
    if (rail && slides.length > 1 && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && e.intersectionRatio > 0.6) { var i = slides.indexOf(e.target); if (i !== idx) mark(i); } });
      }, { root: rail, threshold: [0.6] });
      slides.forEach(function (s) { io.observe(s); });
    }
    return {
      hero: root.querySelector('[data-hs-hero]'),
      thumb0: root.querySelector('[data-hs-thumb="0"] img')
    };
  }

  /* ---------------------------------------------------------------- customer videos
     Arrows name a target index (R-43). Which cards are fully in view comes from an
     IntersectionObserver on the rail (R-89); the click handler is the only layout read. Loops. */
  function bindVideos(root) {
    [].forEach.call(root.querySelectorAll('[data-hs-vstrip]'), function (strip) {
      var rail = strip.querySelector('[data-hs-vrail]');
      var items = [].slice.call(strip.querySelectorAll('[data-hs-vitem]'));
      if (!rail || items.length < 2) return;
      var seen = items.map(function (_, i) { return i === 0; });
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) { var i = items.indexOf(e.target); if (i > -1) seen[i] = e.isIntersecting && e.intersectionRatio > 0.9; });
        }, { root: rail, threshold: [0, 0.9, 1] });
        items.forEach(function (it) { io.observe(it); });
      }
      function first() { for (var i = 0; i < seen.length; i++) if (seen[i]) return i; return 0; }
      function go(i) {
        i = (i + items.length) % items.length;
        [].forEach.call(rail.querySelectorAll('video'), function (v) { if (!v.paused) v.pause(); });
        rail.scrollTo({ left: items[i].offsetLeft - items[0].offsetLeft, behavior: smooth() });
      }
      var prev = strip.querySelector('[data-hs-vprev]'), next = strip.querySelector('[data-hs-vnext]');
      if (prev) prev.addEventListener('click', function () { var i = first(); go(i > 0 ? i - 1 : items.length - 1); });
      if (next) next.addEventListener('click', function () { go(seen[items.length - 1] ? 0 : first() + 1); });
    });
  }

  /* ---------------------------------------------------------------- delivery date
     The design's own function: today + N days. short = "Wed, Oct 28", long = "October 28th". */
  function bindDate(root) {
    var dateEl = root.querySelector('[data-hs-date]');
    if (!dateEl) return;
    var r = new Date(); r.setDate(r.getDate() + (parseInt(root.getAttribute('data-days'), 10) || 0));
    if (root.getAttribute('data-date-format') === 'long') {
      var d = r.getDate();
      var suf = (d > 3 && d < 21) ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[d % 10] || 'th');
      setText(dateEl, r.toLocaleString('en-US', { month: 'long' }) + ' ' + d + suf);
    } else {
      setText(dateEl, r.toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }));
    }
  }

  /* ---------------------------------------------------------------- native purchase */
  function bindPurchase(root, gal) {
    var atc = root.querySelector('[data-hs-atc]');
    var err = root.querySelector('[data-hs-error]');
    function showError(msg) { if (!err) return; err.textContent = msg || ''; err.hidden = !msg; }
    if (!atc) return;
    if (!window.hs || !window.hs.cart) {
      console.error('[hs] hs-purchase.js missing — buy box disabled');
      atc.setAttribute('aria-disabled', 'true');
      atc.addEventListener('click', function () { showError('Adding to cart isn’t available right now. Nothing has been added — please reload the page.'); });
      return;
    }
    var uid = root.id;
    var dataEl = document.querySelector('script[data-hs-product="' + uid + '"]');
    var data = null;
    try { data = dataEl ? JSON.parse(dataEl.textContent) : null; } catch (e) { console.error('[hs] product data unreadable', e); }
    var tiers = [].slice.call(root.querySelectorAll('[data-hs-tier]'));
    var gifts = [].slice.call(root.querySelectorAll('[data-hs-unlock]'));
    var hp = root.querySelector('[data-hs-hprice]'), hc = root.querySelector('[data-hs-hcompare]');
    var hb = root.querySelector('[data-hs-hbadge]'), hs = root.querySelector('[data-hs-hsave]');
    var ap = root.querySelector('[data-hs-aprice]'), ac = root.querySelector('[data-hs-acompare]');
    var hero = gal.hero, thumb0 = gal.thumb0;
    /* data-hs-orig = slide 1's own image; the server already painted the default tier's hero (R-33). */
    var origUrl = hero && hero.getAttribute('data-hs-orig');
    var heroOrig = hero ? { src: origUrl || hero.getAttribute('src') } : null;
    var thumbOrig = origUrl ? origUrl.replace(/width=\d+/, 'width=260') : (thumb0 ? thumb0.getAttribute('src') : null);
    var current = tiers.filter(function (t) { return t.classList.contains('is-active'); })[0] || tiers[0];

    function sellable(t) {
      if (!t || t.getAttribute('data-sellable') !== 'true') return false;
      if (data && data.variant_resolved === false && !t.getAttribute('data-variant')) return false;
      return true;
    }
    function reasonText(t) {
      var r = t && t.getAttribute('data-reason');
      if (!t) return 'There is no option to add yet. Nothing has been added to your cart.';
      if (r === 'unavailable') return 'This option is sold out right now. Nothing has been added to your cart.';
      return 'This option can’t be added right now. Nothing has been added to your cart — please refresh the page.';
    }
    function select(t, focus) {
      if (!t) { atc.setAttribute('aria-disabled', 'true'); return; }
      current = t;
      tiers.forEach(function (x) {
        var on = x === t;
        x.classList.toggle('is-active', on);
        x.setAttribute('aria-checked', on ? 'true' : 'false');
        x.tabIndex = on ? 0 : -1;
      });
      if (focus) t.focus({ preventScroll: true });
      var price = t.getAttribute('data-price') || '', cmp = t.getAttribute('data-compare') || '', save = t.getAttribute('data-save') || '';
      setText(hp, price); setText(ap, price);
      setText(hc, cmp); setText(ac, cmp); if (hc) hc.hidden = !cmp; if (ac) ac.hidden = !cmp;
      setText(hs, save); if (hb) hb.hidden = !save;
      var n = parseInt(t.getAttribute('data-hs-tier'), 10) || 1;
      gifts.forEach(function (g) { g.classList.toggle('is-locked', (parseInt(g.getAttribute('data-hs-unlock'), 10) || 1) > n); });
      var h = t.getAttribute('data-hero');
      if (hero) {
        var want = h || (heroOrig && heroOrig.src);
        if (want && hero.getAttribute('src') !== want && hero.getAttribute('data-hs-shown') !== want) {
          hero.removeAttribute('srcset'); hero.setAttribute('src', want); hero.setAttribute('data-hs-shown', want);
          if (thumb0) thumb0.setAttribute('src', h ? h.replace(/width=\d+/, 'width=260') : thumbOrig);
          if (thumb0) thumb0.removeAttribute('srcset');
        }
      }
      atc.setAttribute('aria-disabled', sellable(t) ? 'false' : 'true');
      showError('');
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () { select(t, false); });
      t.addEventListener('keydown', function (e) {
        var i = tiers.indexOf(t), k = e.key;
        if (k === ' ' || k === 'Enter') { e.preventDefault(); select(t, false); return; }
        if (k === 'ArrowDown' || k === 'ArrowRight') { e.preventDefault(); select(tiers[(i + 1) % tiers.length], true); }
        if (k === 'ArrowUp' || k === 'ArrowLeft') { e.preventDefault(); select(tiers[(i - 1 + tiers.length) % tiers.length], true); }
      });
    });

    var busy = false;
    function setBusy(on) { busy = on; atc.classList.toggle('is-busy', on); atc.setAttribute('aria-busy', on ? 'true' : 'false'); }
    atc.addEventListener('click', function () {
      if (busy) return;
      var t = current;
      if (!sellable(t)) { showError(reasonText(t)); console.error('[hs] PURCHASING DISABLED — tier', t && t.getAttribute('data-hs-tier'), 'reason:', t && t.getAttribute('data-reason')); return; }
      var line = { id: parseInt(t.getAttribute('data-variant'), 10), quantity: parseInt(t.getAttribute('data-qty'), 10) || 1 };
      var plan = t.getAttribute('data-plan'); if (plan) line.selling_plan = parseInt(plan, 10);
      var code = t.getAttribute('data-discount');
      if (code) line.properties = { _hs_offer_discount: code };
      var items = [line];
      /* Bars mode: the tier's gift variants ride along as their own lines (tagged, one each). */
      if (root.getAttribute('data-add-gifts') === 'cart') {
        (t.getAttribute('data-gifts') || '').split(',').forEach(function (g) {
          var gid = parseInt(g, 10);
          if (gid) items.push({ id: gid, quantity: 1, properties: { _hs_gift: 'tier ' + t.getAttribute('data-hs-tier') } });
        });
      }
      setBusy(true); showError('');
      window.hs.cart.add(items).then(function () {
        var mode = root.getAttribute('data-after-add');
        var base = window.hs.cart.root();
        if (mode === 'drawer') {
          var d = document.querySelector('cart-drawer');
          if (d && typeof d.refreshCartDrawer === 'function') { d.refreshCartDrawer(); setBusy(false); return; }
          location.href = base + 'cart'; return;
        }
        if (mode === 'cart') { location.href = base + 'cart'; return; }
        location.href = base + 'checkout' + (code ? '?discount=' + encodeURIComponent(code) : '');
      }, function () {
        setBusy(false);
        showError(window.hs.cart.state().error || 'Something went wrong and nothing was added. Please try again.');
      });
    });
    /* A bfcache restore must not come back with a spinning button (R-128). */
    window.addEventListener('pageshow', function (e) { if (e.persisted) setBusy(false); });

    if (data && data.variant_resolved === false) console.error('[hs] variant unresolved — tiers without a variant id are blocked (R-101)');
    select(current, false);
  }

  function boot(root) {
    if (root.__hsBooted) return; root.__hsBooted = true;
    var gal = bindGallery(root);
    bindVideos(root);
    bindDate(root);
    if (root.getAttribute('data-offer') === 'app') return;
    bindPurchase(root, gal);
  }
  function init() { [].forEach.call(document.querySelectorAll('[data-hs-main]'), boot); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
